
import './select_media_from_library.less';

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';
import classNames from 'classnames';
import Button from 'zoomforth_component_lib/btn_basic.jsx';
import BaseModal from 'zoomforth_component_lib/base_modal.jsx';

import MediaLibraryFoldersByAccount from 'zoomforth_media_library/models/media_library_folder.collection.js';

import { LoadingIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';
import { ALL_MEDIA_LIBRARY_ASSET_TYPES } from 'zoomforth_media_library/const.js';

import { LegacyUploaderInterface } from 'zoomforth_tools/legacy_uploader_interface.js';
import MediaLibraryMain from 'zoomforth_media_library/components/media_library.main.jsx';


class SelectMediaFromLibraryModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      folderLoadState: 'loading',
      selectedAssets: []
    };

    this.uploader = new LegacyUploaderInterface();
    this._mediaLibraryFolderCollection = new MediaLibraryFoldersByAccount();
    autobind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this._mediaLibraryFolderCollection.fetch()
      .done(()=> {
        if (!this.mounted) {
          return;
        }
        this.setState({
          folderLoadState: 'loaded'
        });
      })
      .fail(()=> {
        if (!this.mounted) {
          return;
        }
        this.setState({
          folderLoadState: 'error'
        });
      });

  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getCallingContext() {
    return this.props.multiple ? 'multi' : 'single';
  }

  handleSelectAssets(assets){
    if (this.props.multiple) {
      this.setState({
        selectedAssets: assets
      });

    } else if (assets.length) {
      this.props.onAssetsSelect(assets);
    }
  }

  handleClickSelectAssets() {
    this.props.onAssetsSelect(this.state.selectedAssets);
  }

  render() {

    const {
      currentFolderId,
      enabledMediaTypes,
      enabledMediaWarningMsg,
      multiple,
      selectMediaText,
      onAssetsSelectFail
    } = this.props;

    const shouldWarnAboutEnabledMedia = !!enabledMediaWarningMsg;

    const {
      selectedAssets,
      folderLoadState
    } = this.state;

    const selectedCount = selectedAssets.length;

    return (
      <BaseModal 
        className={classNames('media-library-modal', {'is-selecting-multiple':multiple})}
        modalStyle={{zIndex:1000}}
        onRequestClose={onAssetsSelectFail}
      >
        <div className="close-modal-wrapper">
          <button type="button" className="close" onClick={onAssetsSelectFail}>×</button>
        </div>

        <div 
          className="media-library-selector-wrapper" 
        />

        {
          folderLoadState === 'loading' ?
            <LoadingIcon style={{position:'absolute',top:'50%',left:'50%'}} />

          : folderLoadState === 'loaded' ?

          <Fragment>
            <MediaLibraryMain {...{
              callingContext: this.getCallingContext(),
              folderCollection: this._mediaLibraryFolderCollection,
              initialNavState: {
                folder_id: currentFolderId
              },
              shouldDeemphasizeUpload: true,
              shouldWarnAboutEnabledMedia,
              enabledMediaWarningMsg,
              enabledMediaTypes,
              uploader: this.uploader,
              onAssetsSelect: this.handleSelectAssets
            }} />

            <div className="media-library-selector-footer"> 
              {
                multiple &&
                <Button 
                  className="select-assets-button"
                  disabled={selectedCount === 0} 
                  onClick={this.handleClickSelectAssets}
                  tooltip={selectedCount === 0 ? 'You must select media before continuing' : undefined}
                >
                  { selectMediaText }
                </Button>
              }
              <Button style={{float:'right', marginRight:'3px'}} secondary onClick={onAssetsSelectFail}>
                Cancel
              </Button>
              <div className="selected-count">
                {
                  selectedCount === 0 ?
                    ''
                  :
                    `${selectedCount} asset${selectedCount === 1 ? '' : 's'} selected`
                }
              </div>
            </div>
          </Fragment>

          : 
            null
        }

      </BaseModal>
    );

  }
}


SelectMediaFromLibraryModal.defaultProps = {
  enabledMediaTypes: ALL_MEDIA_LIBRARY_ASSET_TYPES,
  selectMediaText: 'Continue with selected media'
};

SelectMediaFromLibraryModal.propTypes = {
  currentFolderId: PropTypes.number,
  multiple: PropTypes.bool.isRequired,
  enabledMediaTypes: PropTypes.arrayOf(PropTypes.oneOf(ALL_MEDIA_LIBRARY_ASSET_TYPES)),
  enabledMediaWarningMsg: PropTypes.string,
  onAssetsSelect: PropTypes.func.isRequired,
  onAssetsSelectFail: PropTypes.func.isRequired
};

export default SelectMediaFromLibraryModal;
